export default function NotFoundPage() {
  return (
    <div className="p-5 text-center">
      <img src="/assets/404.png" alt="404 - Page not found" className="max-w-md mx-auto mb-4" width={200}/>
      <h1 className="text-4xl mb-3">404 - Page not found</h1>
      <p className="mb-4">Sorry, the page you're looking for doesn't exist.</p>
      <button className="p-button" onClick={() => window.location.href = '/'}>
        Go to home page
      </button>
    </div>
  );
}